<template>
  <v-dialog v-model="isOpen" width="500" @click:outside="close">
    <v-card>
      <v-card-title class="text-h6">
        {{
          finished
            ? "Setor Criado"
            : ticketGroup.id
            ? "Editar setor"
            : "Adicionar setor"
        }}
      </v-card-title>
      <template v-if="!finished">
        <v-tabs v-if="tabs.length > 1" grow v-model="tab">
          <v-tab v-for="tab in tabs" :key="tab.value" :tab-value="tab.value">
            {{ tab.name }}
            <v-chip
              v-if="
                tab.value === 'restrictions' &&
                restrictions.whatsappGroups.length
              "
              small
              class="px-2 ml-2"
            >
              1
            </v-chip>
          </v-tab>
        </v-tabs>
        <v-card-text class="pa-4 pt-2">
          <v-tabs-items v-model="tab">
            <v-tab-item value="benefits">
              <ticket-group-benefits
                ref="benefitsForm"
                :initial-benefits="currentBenefits"
              />
            </v-tab-item>
            <v-tab-item value="details">
              <v-form
                v-model="valid"
                ref="form"
                @submit.prevent="save"
                class="pt-2"
              >
                <v-text-field
                  v-model="ticketGroup.name"
                  :rules="[(v) => !!v || 'Nome é obrigatório']"
                  label="Nome"
                  dense
                  required
                  outlined
                ></v-text-field>
                <v-textarea
                  v-model="ticketGroup.description"
                  label="Descrição"
                  rows="2"
                  auto-grow
                  outlined
                ></v-textarea>
                <v-text-field
                  v-if="party?.maxTickets > 1"
                  v-model="ticketGroup.maxTickets"
                  type="number"
                  label="Máximo de ingressos por conta"
                  dense
                  outlined
                  min="2"
                  :max="party?.maxTickets"
                />
                <v-select
                  v-model="ticketGroup.ageGroup"
                  :items="ageGroupOptions"
                  item-text="name"
                  item-value="id"
                  label="Idade Mínima"
                  dense
                  outlined
                ></v-select>

                <v-select
                  v-if="mapGroups.length"
                  v-model="ticketGroup.tableGroupId"
                  :items="mapGroups"
                  item-text="name"
                  item-value="id"
                  label="Grupo de Assentos"
                  dense
                  outlined
                ></v-select>

                <div class="d-flex justify-space-between">
                  <v-switch
                    class="mt-0"
                    v-model="editColor"
                    label="Cor do mapa"
                  />
                  <div class="flex-shrink-0">
                    <v-menu
                      v-if="editColor"
                      :close-on-content-click="false"
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="d-flex flex-column align-center">
                          <v-avatar
                            v-bind="attrs"
                            v-on="on"
                            class="white--text"
                            :style="{ background: ticketGroup.color }"
                          >
                            <v-icon x-large>mdi-palette</v-icon>
                          </v-avatar>
                        </div>
                      </template>

                      <v-color-picker
                        v-model="ticketGroup.color"
                        dot-size="25"
                        swatches-max-height="100"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
                <div class="d-flex justify-space-between mt-2">
                  <v-switch
                    class="mt-0"
                    v-model="editBraceletColor"
                    label="Cor da pulseira"
                  />
                  <div class="flex-shrink-0">
                    <v-menu
                      v-if="editBraceletColor"
                      :close-on-content-click="false"
                      top
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="d-flex flex-column align-center">
                          <v-avatar
                            v-bind="attrs"
                            v-on="on"
                            class="white--text"
                            :style="{
                              background: ticketGroup.braceletColor,
                            }"
                          >
                            <v-icon x-large>mdi-palette</v-icon>
                          </v-avatar>
                        </div>
                      </template>

                      <v-color-picker
                        v-model="ticketGroup.braceletColor"
                        dot-size="25"
                        swatches-max-height="100"
                      ></v-color-picker>
                    </v-menu>
                  </div>
                </div>
                <v-alert
                  v-if="editBraceletColor"
                  text
                  dense
                  color="info"
                  class="my-2"
                >
                  Após a validaçao do ingresso o sistema irá orientar o operador
                  a colocar uma pulseira com a cor selecionada.
                </v-alert>
              </v-form>
            </v-tab-item>
            <v-tab-item value="restrictions">
              <v-alert type="info" text dense>
                <b>Restrições de Acesso</b> <br />
                Defina restrições para controlar quem pode adquirir ingressos
                <b>online</b> para este setor.
              </v-alert>

              <v-card outlined class="py-2">
                <h6 class="px-4">Ser membro de um dos grupos selecionados</h6>
                <v-list dense class="py-0">
                  <v-list-item v-for="group in whatsappGroups" :key="group.id">
                    <v-list-item-content>
                      <div class="d-flex align-center gap-3">
                        <v-avatar size="32">
                          <v-icon v-if="!group.image">
                            mdi-account-multiple
                          </v-icon>
                          <v-img v-else :src="group.image" />
                        </v-avatar>
                        <p class="mb-0 flex-grow-1 font-weight-bold">
                          {{ group.name }}
                        </p>

                        <v-chip small>
                          <v-icon small left>mdi-account-multiple</v-icon>
                          {{ group.WhatsAppGroupMember.length }}
                        </v-chip>
                        <v-checkbox
                          v-model="restrictions.whatsappGroups"
                          :value="group.id"
                          class="mt-0 pt-0"
                          hide-details
                        />
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-alert v-if="!!error" outlined text color="error">
            {{ error }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="loading" @click="close"> Cancelar </v-btn>
          <v-btn
            class="ml-2"
            color="primary"
            :disabled="loading || !valid"
            :loading="loading"
            @click="save"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </template>

      <!-- Success -->
      <template v-else>
        <v-card-text>
          <v-alert type="success" outlined text>
            <b>Categoria criada com sucesso!</b> <br />
            Para ela ficar ativa, é preciso criar um lote. <br />
            Deseja criar um agora?
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="loading" @click="close">
            finalizar depois
          </v-btn>
          <v-btn
            class="ml-2"
            color="primary"
            :disabled="loading"
            :loading="loading"
            @click="addTicketBlock"
          >
            Criar lote
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import TICKET from "@/services/admin/ticket";
import WHATSAPPGROUP from "@/services/admin/party/whatsappGroup";
import TicketGroupBenefits from "./modules/TicketGroupBenefits.vue";

import { themeWhite } from "@/themeConfig.js";

const defaultTicketGroup = () => ({
  id: null,
  name: "",
  description: "",
  ageGroup: null,
  tableGroupId: null,
  color: null,
  braceletColor: null,
});
const defaultRestrictions = () => ({
  whatsappGroups: [],
});

export default {
  components: {
    TicketGroupBenefits,
  },
  props: {
    party: {
      type: Object,
      default: null,
    },
    tableMap: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    isOpen: false,
    loading: false,
    valid: false,
    error: false,
    finished: false,
    editColor: false,
    editBraceletColor: false,
    ticketGroup: defaultTicketGroup(),
    restrictions: defaultRestrictions(),
    whatsappGroups: [],
    tab: "details",
    themeWhite,
    currentBenefits: null,
  }),

  methods: {
    open(data = {}) {
      this.finished = false;
      this.tab = "details";
      this.isOpen = true;
      this.loadData(data);
      this.$nextTick(() => {
        this.$refs.form.resetValidation();
      });
    },
    loadData(data) {
      const { WhatsappGroups, benefits, ...ticketGroup } = data;
      this.ticketGroup = Object.assign(defaultTicketGroup(), ticketGroup);
      this.currentBenefits = benefits;

      this.editColor = !!this.ticketGroup.color;
      this.restrictions = defaultRestrictions();
      if (this.ticketGroup.color) this.editColor = true;
      else this.editColor = false;
      if (this.ticketGroup.braceletColor) this.editBraceletColor = true;
      else this.editBraceletColor = false;
      if (WhatsappGroups.length)
        this.restrictions.whatsappGroups = WhatsappGroups.map((g) => g.id);
    },
    close() {
      this.finished = false;
      this.tab = "details";
      this.isOpen = false;
      this.loading = false;
      this.error = false;
      this.editColor = false;
      this.ticketGroup = defaultTicketGroup();
      this.restrictions = defaultRestrictions();
      this.currentBenefits = null;

      if (this.$refs.benefitsForm) {
        this.$refs.benefitsForm.setBenefitsData(null);
      }
    },
    addTicketBlock() {
      if (!this.ticketGroup.id) return;
      this.$root.$emit("ticket-block-modal", {
        ticketGroup: this.ticketGroup.id,
      });
      this.close();
    },
    async save() {
      try {
        this.loading = true;
        this.error = false;
        let orgId = this.selectedOrganization.id;
        let { partyId } = this.$route.params;

        const benefits = this.$refs.benefitsForm
          ? this.$refs.benefitsForm.getBenefitsData()
          : this.currentBenefits;

        const updateData = {
          name: this.ticketGroup.name,
          description: this.ticketGroup.description,
          tableGroupId: this.ticketGroup.tableGroupId,
          maxTickets: parseInt(this.ticketGroup.maxTickets),
          ageGroup: this.ticketGroup.ageGroup,
          color: this.editColor ? this.ticketGroup.color : null,
          braceletColor: this.editBraceletColor
            ? this.ticketGroup.braceletColor
            : null,
          restrictions: this.restrictions,
          benefits: benefits,
        };

        if (this.ticketGroup.id) {
          await TICKET.updateTicketGroup(
            orgId,
            partyId,
            this.ticketGroup.id,
            updateData
          );
          this.close();
        } else {
          var { ticketGroup } = await TICKET.createTicketGroup(
            orgId,
            partyId,
            updateData
          );
          this.finished = true;
          this.ticketGroup.id = ticketGroup.id;
        }
        this.$emit("success");
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
    formatName(name) {
      return name
        .split(" ")
        .map((n) => (n.length > 3 ? n.charAt(0).toUpperCase() + n.slice(1) : n))
        .join(" ");
    },
    async loadWhatsappGroups() {
      try {
        let orgId = this.selectedOrganization.id;
        let { partyId } = this.$route.params;
        const { whatsappGroup } = await WHATSAPPGROUP.getAll(orgId, partyId);
        this.whatsappGroups = whatsappGroup;
      } catch (e) {
        console.error(e);
      }
    },
  },
  watch: {
    "ticketGroup.name": {
      handler: function (val) {
        this.ticketGroup.name = this.formatName(val);
      },
      immediate: true,
    },
    editColor: {
      handler: function (val) {
        if (val && !this.ticketGroup.color) {
          this.ticketGroup.color = themeWhite.primary;
        }
      },
    },
    editBraceletColor: {
      handler: function (val) {
        if (val && !this.ticketGroup.braceletColor)
          this.ticketGroup.braceletColor = themeWhite.primary;
      },
    },
  },
  computed: {
    ...mapGetters("organization", ["selectedOrganization"]),
    mapGroups() {
      if (!this.tableMap) return [];
      return this.tableMap.Groups.map((group) => ({
        ...group,
        Tables: group.Tables.reduce(
          (acc, table) => {
            acc.total += 1;
            if (!table.Ticket) acc.available += 1;
            return acc;
          },
          { total: 0, available: 0 }
        ),
      }));
    },

    ageGroupOptions() {
      const baseAge = this.party.ageGroup;
      const options = [];

      if (baseAge === 0) {
        options.push({
          name: `Mesma do evento (Livre)`,
          id: null,
        });
      } else {
        options.push({
          name: `Mesma do evento (${baseAge} anos)`,
          id: null,
        });
      }

      for (let i = Math.max(baseAge || 0, 12); i <= 18; i++) {
        if (i !== baseAge) {
          options.push({ name: `${i} anos`, id: i });
        }
      }

      return options;
    },
    tabs() {
      // if (this.whatsappGroups.length)
      //   return [
      //     {
      //       name: "Detalhes",
      //       value: "details",
      //     },
      //     {
      //       name: "Restrições",
      //       value: "restrictions",
      //     },
      //   ];
      return [
        {
          name: "Detalhes",
          value: "details",
        },
        {
          name: "Benefícios",
          value: "benefits",
        },
      ];
    },
  },
  mounted() {
    this.$root.$on("ticket-group-modal", this.open);
    this.loadWhatsappGroups();
  },
};
</script>

<style></style>
